<template>
    <div style="height: 700px" :style="$vuetify.breakpoint.lgAndUp ? 'width:1280px' : ''" class="wrapper-relative">
        <v-icon class="modal-close" @click.native="CLOSE_MODAL('slider_modal')" aria-hidden="true" translate="no">close</v-icon>
        <v-carousel
            hide-delimiters
            :cycle="false"
            class="slider-modal"
        >
            <v-carousel-item
                v-for="(item,i) in content"
                :key="i"
                :src="item.img_url"
            >
                <v-layout row align-center class="slider__bottom">
                    <v-flex v-show="!$vuetify.breakpoint.xs"
                            align-center
                            justify-center sm2 :class="{'d-flex':!$vuetify.breakpoint.xs}"
                            class="slider__bottom-num pa-4"
                    >{{ i+1 }} / {{ content.length }}</v-flex>
                    <v-flex d-flex align-center xs12
                            sm10
                            class="slider__bottom-text pa-3"
                    >{{ item.content }}</v-flex>
                </v-layout>
            </v-carousel-item>
        </v-carousel>
    </div>
</template>

<script>
import {mapGetters, mapMutations, mapActions} from 'vuex';
export default {
  props: {
    content: {
      type: Array,
    },
  },
  data() {
    return {
      active: true,
    };
  },
  computed: {

  },
  beforeCreate() {
    document.documentElement.style.overflow = 'hidden';
  },
  beforeDestroy() {
    document.documentElement.style.overflow = 'auto';
  },
  methods: {
    ...mapMutations('common/modals', [
      'CLOSE_MODAL',
    ]),
  },
};
</script>

